// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.menubutton {
    display: inline-flex;
    align-items: center;
    height: 2em;
}

div.menubutton-button {
    position: relative;
    flex: 1 1 auto;
    display: flex;
    align-items: center;
    height: 100%;
    background-color: var(--button-bg-color);
    color: var(--button-text-color);
    border: 1px solid var(--border-color);
}

div.menubutton-disabled div.menubutton-button {
    color: var(--text-color-disabled);
}

div.menubutton:not(.menubutton-disabled) div.menubutton-button:active > span.menubutton-button-content,
div.menubutton:not(.menubutton-disabled) div.menubutton-button:active > span.menubotton-button-arrow {
    position: relative!important;
    left: 1px;
    top: 1px;
}

div.menubutton:not(.menubutton-disabled)  div.menubutton-button:hover,
div.menubutton:not(.menubutton-disabled) div.menubutton-button-hover {
    background-color: var(--button-bg-color-hover);
    color: var(--button-text-color-hover);
}

div.menubutton-button-active {
    background-color: var(--button-bg-color-active);
    color: var(--button-text-color-active);
}

div.menubutton:not(.menubutton-disabled) div.menubutton-button-active:hover,
div.menubutton:not(.menubutton-disabled) div.menubutton-button-active.menubutton-button-hover {
    background-color: var(--button-bg-color-active-hover);
    color: var(--button-text-color-active-hover);
}

span.menubutton-button-content {
    padding: 0 0.5em;
    flex: 1 1 auto;
    display: inline-block;
    height: 100%;
    display: flex;
    align-items: center;
}

span.menubutton-button-content span+span {
    margin-left: 0.5em;
}

div.menubutton span.menubotton-button-arrow {
    height: 80%;
    display: flex;
    align-items: flex-end;
    font-size: 80%;
    padding: 0 0.2em;
}

div.menubutton-togglebutton span.menubotton-button-arrow {
    border-left: 1px solid var(--border-color);
}

div.menubutton-menu > div {
    padding: 0.25em;
}

div.menubutton-menu > div.menubutton-menu-active {
    background-color: var(--list-item-bg-color-active);
    color: var(--list-item-text-color-active);
}

div.menubutton-menu > div.menubutton-menu-active:focus {
    background-color: var(--list-item-bg-color-active-hover);
    color: var(--list-item-text-color-active-hover);
}

span.menubutton-tooltip {
    position: absolute;
    display: none;
    background-color: var(--tooltip-bg-color);
    border: 1px solid var(--tooltip-border-color);
    color: var(--tooltip-text-color);
    font-size: 75%;
    font-weight: normal;
    padding: 0.5em;
    border-radius: 0.5em;
    white-space: nowrap;
    left: 50%;
    transform: translateX(-50%);
    z-index: 2;
}

span.menubutton-tooltip-top {
    bottom: 110%;
}

span.menubutton-tooltip-bottom {
    top: 110%;
}

div.menubutton:hover span.menubutton-tooltip {
    display: inline;
}
`, "",{"version":3,"sources":["webpack://./components/widgets/style/MenuButton.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,wCAAwC;IACxC,+BAA+B;IAC/B,qCAAqC;AACzC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;;IAEI,4BAA4B;IAC5B,SAAS;IACT,QAAQ;AACZ;;AAEA;;IAEI,8CAA8C;IAC9C,qCAAqC;AACzC;;AAEA;IACI,+CAA+C;IAC/C,sCAAsC;AAC1C;;AAEA;;IAEI,qDAAqD;IACrD,4CAA4C;AAChD;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,qBAAqB;IACrB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kDAAkD;IAClD,yCAAyC;AAC7C;;AAEA;IACI,wDAAwD;IACxD,+CAA+C;AACnD;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,yCAAyC;IACzC,6CAA6C;IAC7C,gCAAgC;IAChC,cAAc;IACd,mBAAmB;IACnB,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,SAAS;IACT,2BAA2B;IAC3B,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,eAAe;AACnB","sourcesContent":["div.menubutton {\n    display: inline-flex;\n    align-items: center;\n    height: 2em;\n}\n\ndiv.menubutton-button {\n    position: relative;\n    flex: 1 1 auto;\n    display: flex;\n    align-items: center;\n    height: 100%;\n    background-color: var(--button-bg-color);\n    color: var(--button-text-color);\n    border: 1px solid var(--border-color);\n}\n\ndiv.menubutton-disabled div.menubutton-button {\n    color: var(--text-color-disabled);\n}\n\ndiv.menubutton:not(.menubutton-disabled) div.menubutton-button:active > span.menubutton-button-content,\ndiv.menubutton:not(.menubutton-disabled) div.menubutton-button:active > span.menubotton-button-arrow {\n    position: relative!important;\n    left: 1px;\n    top: 1px;\n}\n\ndiv.menubutton:not(.menubutton-disabled)  div.menubutton-button:hover,\ndiv.menubutton:not(.menubutton-disabled) div.menubutton-button-hover {\n    background-color: var(--button-bg-color-hover);\n    color: var(--button-text-color-hover);\n}\n\ndiv.menubutton-button-active {\n    background-color: var(--button-bg-color-active);\n    color: var(--button-text-color-active);\n}\n\ndiv.menubutton:not(.menubutton-disabled) div.menubutton-button-active:hover,\ndiv.menubutton:not(.menubutton-disabled) div.menubutton-button-active.menubutton-button-hover {\n    background-color: var(--button-bg-color-active-hover);\n    color: var(--button-text-color-active-hover);\n}\n\nspan.menubutton-button-content {\n    padding: 0 0.5em;\n    flex: 1 1 auto;\n    display: inline-block;\n    height: 100%;\n    display: flex;\n    align-items: center;\n}\n\nspan.menubutton-button-content span+span {\n    margin-left: 0.5em;\n}\n\ndiv.menubutton span.menubotton-button-arrow {\n    height: 80%;\n    display: flex;\n    align-items: flex-end;\n    font-size: 80%;\n    padding: 0 0.2em;\n}\n\ndiv.menubutton-togglebutton span.menubotton-button-arrow {\n    border-left: 1px solid var(--border-color);\n}\n\ndiv.menubutton-menu > div {\n    padding: 0.25em;\n}\n\ndiv.menubutton-menu > div.menubutton-menu-active {\n    background-color: var(--list-item-bg-color-active);\n    color: var(--list-item-text-color-active);\n}\n\ndiv.menubutton-menu > div.menubutton-menu-active:focus {\n    background-color: var(--list-item-bg-color-active-hover);\n    color: var(--list-item-text-color-active-hover);\n}\n\nspan.menubutton-tooltip {\n    position: absolute;\n    display: none;\n    background-color: var(--tooltip-bg-color);\n    border: 1px solid var(--tooltip-border-color);\n    color: var(--tooltip-text-color);\n    font-size: 75%;\n    font-weight: normal;\n    padding: 0.5em;\n    border-radius: 0.5em;\n    white-space: nowrap;\n    left: 50%;\n    transform: translateX(-50%);\n    z-index: 2;\n}\n\nspan.menubutton-tooltip-top {\n    bottom: 110%;\n}\n\nspan.menubutton-tooltip-bottom {\n    top: 110%;\n}\n\ndiv.menubutton:hover span.menubutton-tooltip {\n    display: inline;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
